import { TAGS_KEYS } from "../../../other/constants/TagsKeys.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import SwivuSettingsIconsTab from "./SwivuResourceIconsTab.jsx";
import { RESOURCE_FONT_SIZE, SETTING_TAB_WIDGET_KEYS } from "../../../other/constants/OtherKeys.jsx";
import { userPreferences } from "../../../react/context/bryntumContext.jsx";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";

export const DEFAULT_ICON_VALUE = "Paste any icon URL from fontawesome.com here."

const GRID_KEYS = {
  iconsGrid: "resourceIconsGrid"
};

export default class SwivuSettingsIconTab extends SwivuSettingsIconsTab {
  static get $name() {
    return "SwivuSettingsIconTab";
  }

  static get type() {
    return "swivusettingsicontab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.iconsTab;
  }

  getStoreName() {
    return STORE_KEYS.resourceTagValuesStore;
  }

  getTagKeysWithWidgetRef() {
    return {
      [TAGS_KEYS.icon]: GRID_KEYS.iconsGrid
    };
  }

  swivuCheckGrants(user) {
    if (!user.can(GRANTS.grant_one)) {
      const grid = this.widgetMap[GRID_KEYS.iconsGrid];
      grid.disabled = true;
      grid.readOnly = true; // readonly will prevent row reorder
      grid.bbar.items.forEach(
        (item) => (item.disabled = true)
      );
    }
  }

  onLoadAppearanceSetting() {
    this.widgetMap.resourceIconSizeField.value = userPreferences.getSetting(PERSISTENCE_STATE_KEYS.resourceIconSize, 'Small');
  }

  onUpdateAppearanceSetting({ source }) {
    if (source.value) {
      // Todo: later check why sometimes on new board opening board setting editor sends a null value to to userprefence for this state
      userPreferences.updateSetting(PERSISTENCE_STATE_KEYS.resourceIconSize, source.value);
    }
  }

  static get configurable() {
    return {
      title: "Icons",
      scrollable: false,
      layoutStyle: {
        flexWrap: "nowrap"
      },
      cls: "p-[1em] flex-col gap-[1em]",
      defaults: {
        labelWidth: "7em",
      },
      items: {
        // We could have used `SwivuSettingsIconsTab` directly in `SwivuSettingsEditor` but for now keep the same structure we follow in other tag type tabs
        [GRID_KEYS.iconsGrid]: SwivuSettingsIconsTab.getGridWidget({
          headerText: "Icon",
          defaultValue: DEFAULT_ICON_VALUE,
        }),
        resourceIconSizeField: {
          label: "Resource Icon Size",
          name: PERSISTENCE_STATE_KEYS.resourceIconSize,
          type: "combo",
          items: Object.keys(RESOURCE_FONT_SIZE),
          onPaint: "up.onLoadAppearanceSetting",
          onChange: "up.onUpdateAppearanceSetting",
        },
      }
    };
  }
}

SwivuSettingsIconTab.initClass();
